import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'

import RouteViewComponent from '../layouts/RouterBypass.vue'
import { permissions } from '../services/utils'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'dashboard' },
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: () => import('../pages/welcome/WelcomePage.vue'),
    meta: { public: true },
  },
  {
    name: 'admin',
    path: '/',
    component: AppLayout,
    redirect: { name: 'dashboard' },
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        component: () => import('../pages/admin/dashboard/Dashboard.vue'),
      },
      {
        name: 'preferences',
        path: 'preferences',
        component: () => import('../pages/preferences/Preferences.vue'),
      },
      {
        name: 'users',
        path: 'users',
        component: () => import('../pages/users/UsersPage.vue'),
      },
      {
        name: 'task',
        path: 'task',
        component: () => import('../pages/tasks/TaskPage.vue'),
      },
      {
        name: 'iptag',
        path: 'iptag',
        component: () => import('../pages/iptags/IptagPage.vue'),
      },
      {
        name: 'list',
        path: 'list',
        component: () => import('../pages/iplists/IplistPage.vue'),
      },
      {
        name: 'rules',
        path: '/rules',
        component: RouteViewComponent,
        children: [
          {
            name: 'rule-iplist',
            path: 'rule-iplist',
            component: () => import('../pages/iplists/IplistPage.vue'),
          },
          {
            name: 'rule-common',
            path: 'rule-common',
            component: () => import('../pages/rules/commonRulePage.vue'),
          },
          {
            name: 'rule-domain',
            path: 'rule-domain',
            component: () => import('../pages/rules/domainRulePage.vue'),
          },
        ],
      },
      {
        name: 'risk',
        path: 'risk',
        component: () => import('../pages/risks/RiskPage.vue'),
      },
      {
        name: 'loginlogs',
        path: 'loginlogs',
        component: () => import('../pages/loginlogs/admin/logsPage.vue'),
        beforeEnter: (to, from, next) => {
          const userPermissions = permissions()
          if (userPermissions.can_view_admin) {
            next()
          } else {
            next({ name: 'loginlogs-user' })
          }
        },
      },
      {
        name: 'loginlogs-user',
        path: 'loginlogs',
        component: () => import('../pages/loginlogs/user/logsPage.vue'),
      },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    meta: { public: true },
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        name: 'signup',
        path: 'signup',
        component: () => import('../pages/auth/Signup.vue'),
      },
      {
        name: 'recover-password',
        path: 'recover-password',
        component: () => import('../pages/auth/RecoverPassword.vue'),
      },
      {
        name: 'recover-password-email',
        path: 'recover-password-email',
        component: () => import('../pages/auth/CheckTheEmail.vue'),
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

router.beforeEach((to, from, next) => {
  const isLoggedIn = Object.keys(permissions()).length > 0
  if (to.meta.public) {
    next()
  } else if (!isLoggedIn) {
    next({ name: 'welcome' })
  } else {
    next()
  }
})

export default router
